import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { Chip, Tooltip } from "@mui/material";
import { useHistory } from "react-router-dom";
import AcademyService from "../../services/AcademyService";

import { Visibility, ReceiptOutlined, Delete } from "@mui/icons-material";
// import DocumentSkeleton from "./DocumentSkeleton";

export default function DocumentTable({
  data,
  meta,
  loading,
  filters,
  setFilters,
}) {
  const history = useHistory();
  const academicService = new AcademyService();
  if (loading) {
    // return <DocumentSkeleton />;
    return <>BUSCANDO....</>;
  }

  const timer = setTimeout(() => {
    // setVisible(false);
  }, 3000);

  const columns = [
    {
      field: "type",
      headerName: "Tipo",
      width: 120,
      valueGetter: (value, row) => row?.type?.name,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: "document",
      headerName: "Documento",
      width: 120,
      valueGetter: (value, row) => row?.document?.full,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: "dni",
      headerName: "DNI / RUC",
      width: 120,
      valueGetter: (value, row) => row?.customer?.dni || "",
      disableColumnMenu: true
    },
    {
      field: "customer",
      headerName: "Receptor",
      minWidth: 280,
      flex: 2,
      valueGetter: (value, row) => row?.customer?.name || "",
      disableColumnMenu: true
    },
    {
      field: "amount",
      headerName: "Monto",
      type: "number",
      valueGetter: (value) => 
      new Intl.NumberFormat('es-PE', { 
        style: 'currency', 
        currency: 'PEN' 
      }).format(value),
      width: 90,
      disableColumnMenu: true
    },
    {
      field: "sunat",
      headerName: "SUNAT",
      width: 120,
      renderCell: (value) => {
        const v = value?.row?.sunat;
        let label = 'PENDIENTE';
        let color = 'warning';

        if (v?.status == 'A'){
          color = 'success';
          label = 'ACEPTADO';
        }else if (v?.status == 'R'){
          color = 'error';
          label = 'RECHAZADO';
        }else if(v?.status == 'X') {
          color = 'info';
          label = 'ANULADO';
        }

        return <Chip color={color} label={label} variant="filled" size="small" />;
      },
      disableColumnMenu: true
    },
    {
      field: "paidAt",
      type: "date",
      headerName: "Fecha",
      width: 120,
      valueFormatter: (value) => {
        if (!value) return "";
        const date = new Date(value);
        // Extrae la fecha en formato UTC (evita que reste tu zona horaria)
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
      },
      disableColumnMenu: true
    },
    {
      field: "actions",
      headerName: "Acciones",
      type: "actions",
      width: 120,
      getActions: (row) => {
        const actions = [];
        actions.push(
          <Tooltip title="Ver comprobante" key="ver">
            <GridActionsCellItem
              icon={<Visibility />}
              color="info"
              label="Ver"
              onClick={() => handleView(row)}
            />
          </Tooltip>
        );

        // if(row?.row?.type?.code !== '07'){
        //   actions.push(
        //     <Tooltip title="Generar Nota de crédito" key="nt">
        //       <GridActionsCellItem
        //         icon={<ReceiptOutlined />}
        //         label="NT"
        //         color="success"
        //         onClick={() => handleEdit(row)}
        //       />
        //     </Tooltip>
        //   );
        // }

        return actions;
      }
    },
    
  ];
  const handleSortModelChange = (model) => {
    if (!model.length) return;
    setFilters({
      ...filters,
      sort_by: model[0].field,
      sort_direction: model[0].sort,
    });
  };

  const handleView = async (row) => {
    const response = await academicService.readPaymentDoc({id: row.id});
    
    history.push(`/invoices/${row.id}/view`, {documents: response.data});
  };

  const handleEdit = async (row) => {
    const response = await academicService.readPaymentDoc({id: row.id});
    console.log(response);
    history.push("/invoices/create-nt", {documents: response.data});
  };

  const handleDelete = (row) => {
    console.log("Eliminar", row);
  };

  return (
    <div>
      <DataGrid
        disableColumnSorting
        rows={data || []}
        columns={columns}
        autoHeight
        rowCount={meta.total || 0}
        paginationMode="server"
        sortingMode="server"
        pageSizeOptions={[10, 20, 50]}
        paginationModel={{
          page: (filters.page || 1) - 1,
          pageSize: filters.per_page || 10,
        }}
        onPaginationModelChange={(model) => {
          setFilters((prev) => ({
            ...prev,
            page: model.page + 1,
            per_page: model.pageSize,
          }));
        }}
        sortModel={[
          {
            field: filters.sort_by,
            sort: filters.sort_direction,
          },
        ]}
        sx={{
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },
        }}
      />
    </div>
  );
}
